<div
    class="head-container d-flex justify-content-between align-items-center shadowed soft-bottom"
>
    <app-widget-header-detail-material
        [title]="title"
        [detail]="detail"
        [icon]="icon"
        [isSectionHeader]="true"
    >
    </app-widget-header-detail-material>

    <div class="group-tools d-inline-flex" >
        <app-button
            [text]="'current-day'"
            class="action rounded shadowed"
            [disabled]="isToday"
            (click)="today()"
        ></app-button>
        <div class="tool">
            <div class="form-group">
                <div class="input-group">
                    <button
                        class="btn btn-outline-secondary calendar"
                        type="button"
                        (click)="toggleCalendar()"
                    >
                        <em class="fa fa-calendar"></em>
                    </button>
                    <input [value]="currentDate" (click)="toggleCalendar()" />
                    <div #datepickerContainer style="display: none">
                        <ngb-datepicker
                            #dp
                            [(ngModel)]="model"
                        ></ngb-datepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
